import Button from "./Button"
import { GoTrash } from "react-icons/go"
import StoresList from "./StoresList"
import { useState } from "react"
import { useRemoveUserMutation } from "../store"

const UsersListItem = ({ user }) => {
  const [removeUser, resultRemoveUser] = useRemoveUserMutation()
  const [showStore, setShowStore] = useState(false)

  const handleRemoveUser = () => {
    removeUser(user)
  }

  const handleClick = () => {
    setShowStore(!showStore)
  }

  const displayUser =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user.email

  return (
    <div>
      <div className="flex flex-row justify-between items-center p-3">
        <div
          onClick={handleClick}
          className="cursor-pointer w-full hover:underline tracking-wider">
          {displayUser}
        </div>
        <Button onClick={handleRemoveUser}>
          <GoTrash />
        </Button>
      </div>
      {showStore && <StoresList owner={user} />}
      {resultRemoveUser.isError && <p>Error while removing the user</p>}
    </div>
  )
}

export default UsersListItem
